const envParam = window.TIEOUT.ENV.ENV_PARAM;

let src;
switch (envParam?.toUpperCase()) {
  case 'PROD':
  case 'BCP':
    src =
      'https://assets.adobedtm.com/58d4dfc81ba0/ca6ed953ccc0/launch-d0f8306f72be.min.js';
    break;
  case 'LOCAL':
    // Skip Adobe Analytics in LOCAL to prevent tracking prevention warnings
    break;
  default:
    src =
      'https://assets.adobedtm.com/58d4dfc81ba0/ca6ed953ccc0/launch-d0f8306f72be.min.js';
    break;
}

if (src) {
  const element = document.createElement('script');
  element.src = src;
  element.async = true;
  document.head.appendChild(element);
}
